<div class="loading-container" *ngIf="!revisionLoaded">
    <circular-indicator style="align-self: center;" [percentage]="0" [size]="100"></circular-indicator>
</div>

<app-no-content *ngIf="revisionLoaded && serviceHistory?.length === 0" type="{{ 'no-services.title' | translate}}" [vin]="vin"></app-no-content>

<div *ngIf="revisionLoaded && serviceHistory !== undefined && serviceHistory.length > 0" class="revision-wrapper">
    <div *ngFor="let h of serviceHistory">
    <lib-accordion [header]="h.revisionName + ' - ' + h.revisionDate" foreground="light">
            <div class="revision-container">
              <section class="revision-container__info">
                <!-- data e hora -->
                <app-card
                  title="{{ 'date-and-hour' | translate | uppercase }}"
                  text="{{ h.formattedRevisionDate }}"
                >
                </app-card>

                <!-- km -->
                <app-card
                  title="{{ 'odometer' | translate | uppercase }}"
                  text="{{ h.kilometers + ' km'}}"
                >
                </app-card>

                <!-- dealer -->
                <app-card
                  *ngIf="h.dealerName !== '' || h.dealerAddress !== ''"
                  title="{{ 'dealer' | translate | uppercase }}"
                  text="{{ h.dealerName }}"
                  optional="{{ h.dealerAddress }}"
                >
                </app-card>
              </section>

              <section class="revision-container__services-performed" *ngIf="h.parts">
                <h2>{{ "services-revision" | translate | uppercase}}</h2>

                <lib-table
                  class="w-100"
                  [elements]="getPartsElements(h.parts)"
                  [alternativeRows]="true"
                  [noBorders]="true"></lib-table>
              </section>
            </div>
        </lib-accordion>
    </div>
</div>
